// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JuRby","textarea":"styles_textarea__2L_B7"};